import React from 'react';

export default function BoxBackpackSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shadow */}
      <ellipse cx="20" cy="37" rx="11" ry="2" fill="#3E2723" opacity="0.15" />
      {/* Straps */}
      <path d="M14 8C14 4 18 3 18 3" stroke="#6D4C41" strokeWidth="2.5" strokeLinecap="round" fill="none" />
      <path d="M26 8C26 4 22 3 22 3" stroke="#6D4C41" strokeWidth="2.5" strokeLinecap="round" fill="none" />
      {/* Handle */}
      <path d="M18 3C18 1 22 1 22 3" stroke="#8D6E63" strokeWidth="2" strokeLinecap="round" fill="none" />
      {/* Main chest body */}
      <rect x="7" y="8" width="26" height="26" rx="4" fill="#A1887F" />
      <rect x="8.5" y="9.5" width="23" height="23" rx="3" fill="#BCAAA4" />
      {/* Lid section */}
      <rect x="8.5" y="9.5" width="23" height="9" rx="3" fill="#A1887F" />
      <rect x="9.5" y="10.5" width="21" height="7" rx="2" fill="#B09688" />
      {/* Lid line */}
      <line x1="8" y1="19" x2="32" y2="19" stroke="#8D6E63" strokeWidth="1.2" />
      {/* Metal corners */}
      <rect x="7" y="8" width="4" height="4" rx="1.5" fill="#B0BEC5" opacity="0.6" />
      <rect x="29" y="8" width="4" height="4" rx="1.5" fill="#B0BEC5" opacity="0.6" />
      <rect x="7" y="30" width="4" height="4" rx="1.5" fill="#B0BEC5" opacity="0.5" />
      <rect x="29" y="30" width="4" height="4" rx="1.5" fill="#B0BEC5" opacity="0.5" />
      {/* Center latch */}
      <rect x="17" y="17" width="6" height="6" rx="1.5" fill="#B0BEC5" />
      <rect x="18" y="18" width="4" height="4" rx="1" fill="#90A4AE" />
      <circle cx="20" cy="20" r="1" fill="#607D8B" />
      {/* Cute face - closed happy eyes */}
      <path d="M14 25C14.5 23.5 16 23.5 16.5 25" stroke="#6D4C41" strokeWidth="1.2" strokeLinecap="round" fill="none" />
      <path d="M23.5 25C24 23.5 25.5 23.5 26 25" stroke="#6D4C41" strokeWidth="1.2" strokeLinecap="round" fill="none" />
      {/* Tiny smile */}
      <path d="M18 28C19 29 21 29 22 28" stroke="#6D4C41" strokeWidth="1" strokeLinecap="round" fill="none" />
      {/* Blush spots */}
      <circle cx="13.5" cy="27" r="1.8" fill="#E8A0A0" opacity="0.35" />
      <circle cx="26.5" cy="27" r="1.8" fill="#E8A0A0" opacity="0.35" />
      {/* Shine */}
      <path d="M11 12L12 11" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.3" />
    </svg>
  );
}
